<template>
	<div class="project" v-if="projectData">
		<project-name
			v-model="projectData.title"
			:readonly="true"
		></project-name>
		<ProjectReadOnlyHeader :project-data="projectData" :requested-dotation="requestedDotation"/>
		<BidderNameReadOnlyView :view-data="projectData"/>
		<contest-offer-activities-description
			class="d-none print-only"
			:actions="projectData.actionsData"
			:contestId="projectData.contestId"
		></contest-offer-activities-description>
	</div>
</template>

<script>
	import ProjectName from "./components/ProjectName";
	import ProjectReadOnlyHeader from "./ProjectReadOnlyHeader";
	import {Project} from "../../../api/generated/Project";
	import {Api} from "../../../api";
	import ContestOfferActivitiesDescription from "../offer/components/ContestOfferActivitiesDescription";
	import BidderNameReadOnlyView from "../offer/components/ReadOnlyComponents/BidderNameReadOnlyView";

	export default {
		name: "ProjectReadOnlyActivitiesView",
		components: {BidderNameReadOnlyView, ContestOfferActivitiesDescription, ProjectReadOnlyHeader, ProjectName},

		data () {
			return {
				projectData: null,
			};
		},

		created () {
			this.loadData();
		},

		methods: {
			async loadData () {
				Project.getRequestedDotation(this, this.$route.params.projectId, successResponse => {
						this.requestedDotation = successResponse.requestedDotation;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować wnioskowanej kwoty dotacji", errorResponse);
					});

				// Pobranie danych projektu
				let path;
				if (this.$route.params.version) {
					path = "/project/data-version?projectId=".concat(this.$route.params.projectId).concat("&version=".concat(this.$route.params.version));
				} else {
					path = "/project/readonly?projectId=".concat(this.$route.params.projectId);
				}
				await Api.syncGet(
					this,
					path,
					response => {
						this.projectData = response;
					});
			},
		}
	};
</script>

<style scoped>

</style>